import { formatDuration, formatISODuration, intervalToDuration } from 'date-fns';
import { getLocale } from './common';

export const getDurationLabel = (localeCode: string, durationInMs: number = 0) => {
  const locale = getLocale(localeCode);

  const duration = intervalToDuration({
    start: 0,
    end: durationInMs,
  });

  return formatDuration(duration, { locale });
};

/**
 * @return An ISO 8601 duration formatted string representing the duration passed in. Suitable to use for the `datetime` attribute of the `<time>` element.
 */
export const getDurationDateTime = (durationInMs: number = 0) => {
  const duration = intervalToDuration({
    start: 0,
    end: durationInMs,
  });

  return formatISODuration(duration);
};
